var ibmContactController = (function () {
    function ibmContactController() {
    }
    ibmContactController.prototype.openContact = function () {
        this.className = "ibm-active";
    };
    ibmContactController.prototype.closeContact = function () {
        this.className = "";
    };
    return ibmContactController;
}());
var ibmContactComponent = (function () {
    function ibmContactComponent() {
        this.templateUrl = 'home-contact.html';
        this.controllerAs = 'vm';
        this.controller = ibmContactController;
    }
    return ibmContactComponent;
}());
angular
    .module('application')
    .component('ibmContactModule', new ibmContactComponent());

//# sourceMappingURL=home.contact.component.js.map
